import React from 'react';
import AiSkeleton, { SkeletonCircle, SkeletonText } from '../../common/AiSkeleton';

/**
 * 채팅 메시지 목록 로딩을 위한 스켈레톤 UI.
 * ChatMessage의 레이아웃을 모사합니다.
 */
const ChatMessageSkeleton = ({ count = 3 }) => {
    return (
        <div className="flex flex-col gap-6 w-full">
            {Array.from({ length: count }).map((_, i) => {
                const isUser = i % 2 !== 0; // 사용자/AI 번갈아가며 표시
                
                return (
                    <div 
                        key={i} 
                        className={`flex gap-3 items-start ${isUser ? 'flex-row-reverse' : ''} animate-fade-in`}
                    >
                        {/* 프로필 서클 */}
                        <SkeletonCircle size="36px" className="flex-shrink-0" />
                        
                        <div className={`flex flex-col max-w-[70%] ${isUser ? 'items-end' : ''} space-y-2`}>
                            {/* 메시지 박스 스켈레톤 */}
                            <AiSkeleton 
                                variant="rect" 
                                className={`h-12 w-48 sm:w-64 ${isUser ? 'rounded-tr-none bg-blue-50' : 'rounded-tl-none bg-gray-50'}`} 
                            />
                            {/* 시간 표시 스켈레톤 */}
                            <SkeletonText width="40px" className="h-2 opacity-50" />
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default ChatMessageSkeleton;
